var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, Watch, } from "vue-property-decorator";
import { isNumber, isTubeProfileGeometryCircular, isTubeProfileGeometryRectangular, thicknessEquivalence, } from "../utilities/wsi4_typeguards";
import ThicknessSelect from "../../components/articleattributes/thicknessselect.vue";
import { TubeProfileGeometryType, } from "../utilities/wsi4_interfaces";
let TubeProfileSelection = class TubeProfileSelection extends Vue {
    constructor() {
        super(...arguments);
        this.index = 0;
    }
    onChange() {
        return this.tubeProfileId;
    }
    createThickness(t) {
        return {
            name: this.i18n.numberWithTwoDecimals(t),
            number: t,
            invalid: undefined,
        };
    }
    createRectangularDimension(r) {
        return {
            dimY: r.dimY,
            dimZ: r.dimZ,
            text: this.i18n.numberWithTwoDecimals(r.dimY) + " x " + this.i18n.numberWithTwoDecimals(r.dimZ),
        };
    }
    createCircularDimension(c) {
        return {
            outerRadius: c.outerRadius,
            text: this.i18n.numberWithTwoDecimals(c.outerRadius),
        };
    }
    onTubeProfileTypeChange(event) {
        const profileType = this.tubeProfileTypes[event.target.selectedIndex];
        this.index = this.allowedTubeProfiles.findIndex(t => t.geometryType === profileType);
        this.onChange();
    }
    onThicknessChange(thickness) {
        if (!isNumber(thickness)) {
            throw Error("Wrong type.");
        }
        this.index = this.allowedTubeProfiles.findIndex(t => t.geometryType === this.allowedTubeProfiles[this.index].geometryType && thicknessEquivalence(t.geometry.thickness, thickness));
        this.onChange();
    }
    onRectangularDimensionChange(event) {
        const rect = this.rectangularDimensions[event.target.selectedIndex];
        const tubeProfile = this.allowedTubeProfiles[this.index];
        if (tubeProfile.geometryType !== TubeProfileGeometryType.rectangular) {
            throw Error("Wrong type.");
        }
        this.index = this.allowedTubeProfiles.findIndex(t => {
            if (t.geometryType !== tubeProfile.geometryType) {
                return false;
            }
            if (!thicknessEquivalence(t.geometry.thickness, tubeProfile.geometry.thickness)) {
                return false;
            }
            if (!isTubeProfileGeometryRectangular(t.geometry)) {
                throw Error("Wrong type.");
            }
            return t.geometry.dimY === rect.dimY && t.geometry.dimZ === rect.dimZ;
        });
        this.onChange();
    }
    onCircularDimensionChange(event) {
        const circ = this.circularDimensions[event.target.selectedIndex];
        const tubeProfile = this.allowedTubeProfiles[this.index];
        if (tubeProfile.geometryType !== TubeProfileGeometryType.circular) {
            throw Error("Wrong type.");
        }
        this.index = this.allowedTubeProfiles.findIndex(t => {
            if (t.geometryType !== tubeProfile.geometryType) {
                return false;
            }
            if (!thicknessEquivalence(t.geometry.thickness, tubeProfile.geometry.thickness)) {
                return false;
            }
            if (!isTubeProfileGeometryCircular(t.geometry)) {
                throw Error("Wrong type.");
            }
            return t.geometry.outerRadius === circ.outerRadius;
        });
        this.onChange();
    }
    initialize() {
        const index = this.allowedTubeProfiles.findIndex(t => t.identifier === this.originalTubeProfileId);
        if (index !== this.index) {
            this.index = index;
            this.onChange();
        }
    }
    get allowedTubeProfiles() {
        return this.shopConfig.tubeProfiles.filter(t => this.tubeProfiles.some(id => id === t.identifier));
    }
    get tubeProfile() {
        if (this.index < 0 || this.index >= this.allowedTubeProfiles.length) {
            return undefined;
        }
        return this.allowedTubeProfiles[this.index];
    }
    get tubeProfileId() {
        if (this.tubeProfile === undefined) {
            return "";
        }
        return this.tubeProfile.identifier;
    }
    get tubeProfileType() {
        if (this.tubeProfile === undefined) {
            return undefined;
        }
        return this.tubeProfile.geometryType;
    }
    get thickness() {
        if (this.tubeProfile === undefined) {
            return undefined;
        }
        return this.createThickness(this.tubeProfile.geometry.thickness);
    }
    get rectangularDimension() {
        if (this.tubeProfile === undefined) {
            return undefined;
        }
        if (this.tubeProfile.geometryType !== TubeProfileGeometryType.rectangular) {
            return undefined;
        }
        if (!isTubeProfileGeometryRectangular(this.tubeProfile.geometry)) {
            throw Error("Wrong type.");
        }
        return this.createRectangularDimension(this.tubeProfile.geometry);
    }
    get circularDimension() {
        if (this.tubeProfile === undefined) {
            return undefined;
        }
        if (this.tubeProfile.geometryType !== TubeProfileGeometryType.circular) {
            return undefined;
        }
        if (!isTubeProfileGeometryCircular(this.tubeProfile.geometry)) {
            throw Error("Wrong type.");
        }
        return this.createCircularDimension(this.tubeProfile.geometry);
    }
    get tubeProfileTypes() {
        return this.allowedTubeProfiles.map(t => t.geometryType)
            .filter((geometryType, index, self) => self.findIndex(c => c === geometryType) === index);
    }
    get thicknessConfig() {
        const tp = this.tubeProfile;
        if (tp === undefined) {
            return [];
        }
        return this.allowedTubeProfiles.filter(t => t.geometryType === tp.geometryType)
            .map(t => t.geometry.thickness)
            .filter((thickness, index, self) => self.findIndex(c => thicknessEquivalence(c, thickness)) === index)
            .sort((a, b) => a < b ? -1 : (a === b ? 0 : 1))
            .map(t => this.createThickness(t));
    }
    get rectangularDimensions() {
        const tp = this.tubeProfile;
        if (tp === undefined) {
            return [];
        }
        if (tp.geometryType === TubeProfileGeometryType.circular) {
            return [];
        }
        return this.allowedTubeProfiles.filter(t => t.geometryType === tp.geometryType && thicknessEquivalence(t.geometry.thickness, tp.geometry.thickness))
            .map(t => {
            if (!isTubeProfileGeometryRectangular(t.geometry)) {
                throw Error("Wrong geometry");
            }
            return this.createRectangularDimension(t.geometry);
        });
    }
    get circularDimensions() {
        const tp = this.tubeProfile;
        if (tp === undefined) {
            return [];
        }
        if (tp.geometryType === TubeProfileGeometryType.rectangular) {
            return [];
        }
        return this.allowedTubeProfiles.filter(t => t.geometryType === tp.geometryType && thicknessEquivalence(t.geometry.thickness, tp.geometry.thickness))
            .map(t => {
            if (!isTubeProfileGeometryCircular(t.geometry)) {
                throw Error("Wrong geometry");
            }
            return this.createCircularDimension(t.geometry);
        });
    }
    mounted() {
        this.initialize();
    }
    originalTubeIdChanged() {
        this.initialize();
    }
};
__decorate([
    Prop({ required: true })
], TubeProfileSelection.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], TubeProfileSelection.prototype, "tubeProfiles", void 0);
__decorate([
    Prop({ required: true })
], TubeProfileSelection.prototype, "originalTubeProfileId", void 0);
__decorate([
    Prop({ required: true })
], TubeProfileSelection.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], TubeProfileSelection.prototype, "showNumbers", void 0);
__decorate([
    Inject()
], TubeProfileSelection.prototype, "i18n", void 0);
__decorate([
    Emit()
], TubeProfileSelection.prototype, "onChange", null);
__decorate([
    Watch("originalTubeProfileId")
], TubeProfileSelection.prototype, "originalTubeIdChanged", null);
TubeProfileSelection = __decorate([
    Component({
        components: {
            ThicknessSelect,
        },
        name: "TubeProfileSelection",
    })
], TubeProfileSelection);
export default TubeProfileSelection;
